<template>
	<div class="userInfo_box flex">
		<div class="menu">
			<div class="login_out" @click="loginOut">Log Out</div>
			<div class="user_detail">
				<div class="title">My account</div>
				<div class="photo" @click="toUser">
					<img :src="userInfo.avatar ? imgBaseUrl + userInfo.avatar : require('../../../assets/images/icon/photo1.png')" alt="">
				</div>
				<div class="name">{{userInfo.first_name}}</div>
				<div class="user_item first flex align-center">
					<img src="../../../assets/images/icon/user.png" alt="">
					<div class="val">{{userInfo.first_name}} {{userInfo.last_name}}</div>
				</div>
				<div class="user_item flex align-center">
					<img src="../../../assets/images/icon/email.png" alt="">
					<div class="val">{{userInfo.email ? userInfo.email :'Email'}}</div>
				</div>
				<div class="user_item flex align-center" @click="toFail">
					<img src="../../../assets/images/icon/phone.png" alt="">
					<div class="val">{{userInfo.mobile ? userInfo.mobile :'Mobile'}}</div>
				</div>
				<div class="user_item flex align-center justify-between" @click="toIntegral">
					<div class="left flex align-center">
						<img src="../../../assets/images/icon/integral.png" alt="">
						<div class="val">Reward Points：{{userInfo.score}}</div>
					</div>
					<img class="right" src="../../../assets/images/icon/right2.png" alt="">
				</div>
				<div class="user_item flex align-center justify-between" @click="toPackage">
					<div class="left flex align-center">
						<img src="../../../assets/images/icon/set.png" alt="">
						<div class="val">Class Pack：{{userInfo.combo_num}} Classes</div>
					</div>
					<img class="right" src="../../../assets/images/icon/right2.png" alt="">
				</div>
				<!-- <div class="user_item flex align-center justify-between" @click="toEvent">
					<div class="left flex align-center">
						<img src="../../../assets/images/icon/card.png" alt="">
						<div class="val">Events Order</div>
					</div>
					<img class="right" src="../../../assets/images/icon/right2.png" alt="">
				</div> -->
			</div>
			<div class="add_child" @click="toChangePwd">Change Password</div>
			<div class="add_child" @click="toUser">Edit</div>
			<div class="user_detail child_detail">
				<div class="title">Child Info</div>
				<div v-for="(item,index) in childList" :key="index">
					<div class="photo" @click="toChild(item.id)">
						<img :src=" item.avatar ? imgBaseUrl+item.child_avatar : require('../../../assets/images/icon/photo.png')" alt="">
					</div>
					<div class="name">{{item.child_first_name}}</div>
					<div class="user_item first flex align-center">
						<img src="../../../assets/images/icon/user.png" alt="">
						<div class="val">{{item.child_first_name}} {{item.child_last_name}}</div>
					</div>
					<div class="user_item flex align-center">
						<img src="../../../assets/images/icon/date.png" alt="">
						<div class="val">{{item.birthday}}</div>
					</div>
					<div class="user_item flex align-center">
						<img src="../../../assets/images/icon/phone.png" alt="">
						<div class="val">{{item.contact_mobile_one ? item.contact_mobile_one : 'Mobile'}}</div>
					</div>
					<div class="user_item flex align-center">
						<img src="../../../assets/images/icon/user2.png" alt="">
						<div class="val">Pick-up contact:{{item.nanny_contact}}</div>
					</div>
					<div class="add_child" @click="toChild(item.id)">Edit</div>
				</div>
			</div>
			
			<div class="add_child" @click="toAddChild">Add a child</div>
		</div>
		<div class="userinfo_detail">
			<router-view ></router-view>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				imgBaseUrl:this.$api.imgBaseUrl,
				userInfo:{},
				childList:[]
			}
		},
		created(){
			this.getUser();
			this.getChildList();
			let _this = this //很重要把父路由的vue实例赋给_this
			_this.$root.$on('changeUser', function (idName, router) {  //监听next事件，这里$root很重要，不懂去官网介绍
				_this.getUser() //调用父路由中的方法
			})
			_this.$root.$on('changeChild', function (idName, router) {  //监听next事件，这里$root很重要，不懂去官网介绍
				_this.getChildList() //调用父路由中的方法
			})
		},
		methods:{
			getUser(){
				this.$api.post('user/getUserDetails',{},res=>{
					if(res.code == 1){
						this.userInfo = res.data;
					}
				})
			},
			loginOut(){
				localStorage.removeItem('token');
				this.$router.push('/login')
			},
			toFail(){
				this.$router.push('/home/userInfo/payFail')
			},
			getChildList(){
				this.$api.post('user/getChildList',{},res=>{
					if(res.code == 1){
						this.childList = res.data;
						this.$forceUpdate()
					}
				})
			},
			toUser(){
				this.$router.push('/home/userInfo/user')
			},
			toChangePwd(){
				this.$router.push('/home/userInfo/changePwd')
			},
			toCard(){
				
				this.$router.push('/home/userInfo/card')
			},
			toIntegral(){
				this.$router.push('/home/userInfo/integral')
			},
			toAddChild(){
				this.$router.push('/home/userInfo/editChild')
			},
			toPackage(){
				this.$router.push('/home/userInfo/package')
			},
			toEvent(){
				this.$router.push('/home/userInfo/eventOrder')
			},
			toChild(id){
				this.$router.push({path:'/home/userInfo/child',query:{id:id}})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.userInfo_box{
		width: 100%;
		min-height: 100vh;
		transform: scale(0.72);
		transform-origin:100px 0;
		.menu{
			width: 330px;
			flex-shrink: 0;
			height: auto;
			// height: 100%;
			background: #F7F2EB;
			box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3);
			padding: 0 10px 50px;
			position: relative;
			.login_out{
				position: absolute;
				top: 20px;
				right: 10px;
				width: 110px;
				height: 40px;
				background: #5C707A;
				border-radius: 20px;
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #F7F2EB;
				text-align: center;
				line-height: 40px;
				cursor: pointer;
			}
			.user_detail{
				padding-top: 60px;
				&.child_detail{
					padding-top: 80px;
				}
				.title{
					font-size: 20px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					text-align: center;
				}
				.photo{
					margin: 30px auto 20px;
					width: 122px;
					height: 122px;
					border-radius: 50%;
					overflow: hidden;
					cursor: pointer;
				}
				.name{
					font-size: 20px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					text-align: center;
					margin-bottom: 30px;
				}
				.user_item{
					width: 100%;
					height: 62px;
					border-bottom: 1px solid #5C707A;
					padding: 0 20px 0 17px;
					cursor: pointer;
					&.first{
						border-top: 1px solid #5C707A;
					}
					img{
						width: 18px;
						height: 21px;
					}
					.val{
						font-size: 20px;
						font-family: Source Han Sans CN;
						font-weight: bold;
						color: #282E30;
						margin-left: 30px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
					.right{
						width: 10px;
						height: 18px;
					}
				}
			}
		}
		.add_child{
			width: 200px;
			height: 57px;
			background: #5C707A;
			border-radius: 29px;
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #F7F2EB;
			text-align: center;
			line-height: 57px;
			margin: 20px auto 0;
			cursor: pointer;
		}
		.userinfo_detail{
			width: 100%;
			
		}
	}
</style>